import { render, staticRenderFns } from "./quanqiu.vue?vue&type=template&id=1e763efa&scoped=true&"
import script from "./quanqiu.vue?vue&type=script&lang=js&"
export * from "./quanqiu.vue?vue&type=script&lang=js&"
import style0 from "./quanqiu.vue?vue&type=style&index=0&id=1e763efa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e763efa",
  null
  
)

export default component.exports